import React from 'react';
import {Col, Row} from 'antd';

export default class Correlation extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
			{/* <Container> */}
				<Row>
					<Col span={8}>
						<h3>Correlation: GDP and Suicide Rate</h3>
						<img src={require(`./CorrelationPlots/${this.props.year}_GDP_totalRate.png`)} width='400' height='400' />
					</Col>
					<Col span={8}>
						<h3>Correlation: Male Suicide Rate and Female Suicide Rate</h3>
						<img src={require(`./CorrelationPlots/${this.props.year}_maleRate_femaleRate.png`)} width='400' height='400' />
					</Col>
					<Col span={8}>
					<h3>Correlation: Population and Suicide Rate</h3>
						<img src={require(`./CorrelationPlots/${this.props.year}_Population_totalRate.png`)} width='400' height='400' />
					</Col>
				</Row>
			{/* </Container> */}
			</div>
		);
	}


}